/**
 * Sport quick-picks for the self-serve club creation wizard (slice 2).
 *
 * `teams` are the sport-appropriate quick-pick chips for the "Add your teams"
 * step — a starting point, not a constraint (free-text add sits alongside).
 * `clubs.sport` is free-text VARCHAR(100) in the DB, so "Other" simply passes
 * whatever the founder types.
 */

export const SPORTS = [
  {
    key: 'Rugby Union',
    label: 'Rugby Union',
    emoji: '🏉',
    teams: [
      { name: 'U6s', ageGroup: 'U6' }, { name: 'U7s', ageGroup: 'U7' },
      { name: 'U8s', ageGroup: 'U8' }, { name: 'U9s', ageGroup: 'U9' },
      { name: 'U10s', ageGroup: 'U10' }, { name: 'U11s', ageGroup: 'U11' },
      { name: 'U12s', ageGroup: 'U12' }, { name: 'U13s', ageGroup: 'U13' },
      { name: 'U14s', ageGroup: 'U14' }, { name: 'U15s', ageGroup: 'U15' },
      { name: 'U16s', ageGroup: 'U16' }, { name: 'Colts (U18)', ageGroup: 'U18' },
      { name: '1st XV', ageGroup: 'Senior' }, { name: '2nd XV', ageGroup: 'Senior' },
      { name: '3rd XV', ageGroup: 'Senior' }, { name: 'Women', ageGroup: 'Senior' },
      { name: 'Girls', ageGroup: 'Junior' }, { name: 'Vets', ageGroup: 'Senior' },
    ],
  },
  {
    key: 'Rugby League',
    label: 'Rugby League',
    emoji: '🏉',
    teams: [
      { name: 'U7s', ageGroup: 'U7' }, { name: 'U9s', ageGroup: 'U9' },
      { name: 'U11s', ageGroup: 'U11' }, { name: 'U13s', ageGroup: 'U13' },
      { name: 'U15s', ageGroup: 'U15' }, { name: 'U16s', ageGroup: 'U16' },
      { name: 'U18s', ageGroup: 'U18' },
      { name: 'Open Age', ageGroup: 'Senior' }, { name: 'A Team', ageGroup: 'Senior' },
      { name: 'Women', ageGroup: 'Senior' }, { name: 'Masters', ageGroup: 'Senior' },
    ],
  },
  {
    key: 'Football',
    label: 'Football',
    emoji: '⚽',
    teams: [
      { name: 'U7s', ageGroup: 'U7' }, { name: 'U8s', ageGroup: 'U8' },
      { name: 'U9s', ageGroup: 'U9' }, { name: 'U10s', ageGroup: 'U10' },
      { name: 'U11s', ageGroup: 'U11' }, { name: 'U12s', ageGroup: 'U12' },
      { name: 'U13s', ageGroup: 'U13' }, { name: 'U14s', ageGroup: 'U14' },
      { name: 'U15s', ageGroup: 'U15' }, { name: 'U16s', ageGroup: 'U16' },
      { name: 'U18s', ageGroup: 'U18' },
      { name: '1st Team', ageGroup: 'Senior' }, { name: 'Reserves', ageGroup: 'Senior' },
      { name: 'Women', ageGroup: 'Senior' }, { name: 'Girls', ageGroup: 'Junior' },
      { name: 'Vets', ageGroup: 'Senior' },
    ],
  },
  {
    key: 'Cricket',
    label: 'Cricket',
    emoji: '🏏',
    teams: [
      { name: 'All Stars (5–8)', ageGroup: 'U8' }, { name: 'Dynamos (8–11)', ageGroup: 'U11' },
      { name: 'U11s', ageGroup: 'U11' }, { name: 'U13s', ageGroup: 'U13' },
      { name: 'U15s', ageGroup: 'U15' }, { name: 'U18s', ageGroup: 'U18' },
      { name: '1st XI', ageGroup: 'Senior' }, { name: '2nd XI', ageGroup: 'Senior' },
      { name: '3rd XI', ageGroup: 'Senior' }, { name: 'Sunday XI', ageGroup: 'Senior' },
      { name: 'Women', ageGroup: 'Senior' },
    ],
  },
  {
    key: 'Hockey',
    label: 'Hockey',
    emoji: '🏑',
    teams: [
      { name: 'U8s', ageGroup: 'U8' }, { name: 'U10s', ageGroup: 'U10' },
      { name: 'U12s', ageGroup: 'U12' }, { name: 'U14s', ageGroup: 'U14' },
      { name: 'U16s', ageGroup: 'U16' }, { name: 'U18s', ageGroup: 'U18' },
      { name: "Men's 1s", ageGroup: 'Senior' }, { name: "Men's 2s", ageGroup: 'Senior' },
      { name: "Ladies' 1s", ageGroup: 'Senior' }, { name: "Ladies' 2s", ageGroup: 'Senior' },
      { name: 'Mixed', ageGroup: 'Senior' },
    ],
  },
  {
    key: 'Netball',
    label: 'Netball',
    emoji: '🏐',
    teams: [
      { name: 'U11s', ageGroup: 'U11' }, { name: 'U12s', ageGroup: 'U12' },
      { name: 'U14s', ageGroup: 'U14' }, { name: 'U16s', ageGroup: 'U16' },
      { name: 'A Team', ageGroup: 'Senior' }, { name: 'B Team', ageGroup: 'Senior' },
      { name: 'C Team', ageGroup: 'Senior' },
    ],
  },
];

// Generic quick-picks for "Other" / unrecognised sports.
export const GENERIC_TEAMS = [
  { name: 'U8s', ageGroup: 'U8' }, { name: 'U10s', ageGroup: 'U10' },
  { name: 'U12s', ageGroup: 'U12' }, { name: 'U14s', ageGroup: 'U14' },
  { name: 'U16s', ageGroup: 'U16' }, { name: 'U18s', ageGroup: 'U18' },
  { name: '1st Team', ageGroup: 'Senior' }, { name: '2nd Team', ageGroup: 'Senior' },
  { name: 'Women', ageGroup: 'Senior' }, { name: 'Juniors', ageGroup: 'Junior' },
];

export const quickPicksForSport = (sport) => {
  const match = SPORTS.find(s => s.key.toLowerCase() === String(sport || '').trim().toLowerCase());
  return match ? match.teams : GENERIC_TEAMS;
};
